export const sendTypeOptions = [
    { label: "Email", value: "email" },
    { label: "WhatsApp", value: "wpp" }
]